import '../Styles/Header.css';
import logoBackGround from '../Images/logoBackGround.jpg';
export function MainHeader(){
    return(
        <div className='headerMainDiv'>
            <div className='headerLeftDiv'>
            </div>
            <div className='headerMidDiv'>
                {/* <img src={logoBackGround} alt="title" /> */}
                <h1 className='title'>الجمعية الإجتماعية السودانية</h1>
                <h1 className='title' id='title2'>The Sudanese Sociality Association</h1>
                <h3 className='title'>Cedar Rapids, Iowa</h3>
                <h3 className='title'>ssac52404@gmail.com</h3>
                <h3 className='title'>+1 (319) 497-3659</h3>
            </div>
            <div className='headerRightDiv'></div>
        </div>
    )
}